module.exports = __webpack_public_path__ + "static/media/mundo-em-noticias-end.72c63f3d.png";